import { ref as P, computed as O } from "vue";
import { getFlagOfOrder as j } from "./ghl-ui.es1324.js";
import { call as s } from "./ghl-ui.es925.js";
function d(o) {
  return typeof o == "object" && typeof o.multiple == "number" ? o.multiple : !1;
}
function k(o, u) {
  return u && (o === void 0 || o === "default" || typeof o == "object" && o.compare === "default") ? w(u) : typeof o == "function" ? o : o && typeof o == "object" && o.compare && o.compare !== "default" ? o.compare : !1;
}
function w(o) {
  return (u, c) => {
    const f = u[o], l = c[o];
    return typeof f == "number" && typeof l == "number" ? f - l : typeof f == "string" && typeof l == "string" ? f.localeCompare(l) : 0;
  };
}
function T(o, { dataRelatedColsRef: u, filteredDataRef: c }) {
  const f = [];
  u.value.forEach((e) => {
    var r;
    e.sorter !== void 0 && v(f, {
      columnKey: e.key,
      sorter: e.sorter,
      order: (r = e.defaultSortOrder) !== null && r !== void 0 ? r : !1
    });
  });
  const l = P(f), a = O(() => {
    const e = u.value.filter((n) => n.type !== "selection" && n.sorter !== void 0 && (n.sortOrder === "ascend" || n.sortOrder === "descend" || n.sortOrder === !1)), r = e.filter((n) => n.sortOrder !== !1);
    if (r.length)
      return r.map((n) => ({
        columnKey: n.key,
        // column to sort has controlled sorter
        // sorter && sort order won't be undefined
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        order: n.sortOrder,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sorter: n.sorter
      }));
    if (e.length)
      return [];
    const { value: t } = l;
    return Array.isArray(t) ? t : t ? [t] : [];
  }), h = O(() => {
    const e = a.value.slice().sort((r, t) => {
      const n = d(r.sorter) || 0;
      return (d(t.sorter) || 0) - n;
    });
    return e.length ? c.value.slice().sort((t, n) => {
      let i = 0;
      return e.some((U) => {
        const { columnKey: F, sorter: N, order: S } = U, g = k(N, F);
        return g && S && (i = g(t.rawNode, n.rawNode), i !== 0) ? (i = i * j(S), !0) : !1;
      }), i;
    }) : c.value;
  });
  function b(e) {
    let r = a.value.slice();
    return e && d(e.sorter) !== !1 ? (r = r.filter((t) => d(t.sorter) !== !1), v(r, e), r) : e || null;
  }
  function p(e) {
    const r = b(e);
    y(r);
  }
  function y(e) {
    const { "onUpdate:sorter": r, onUpdateSorter: t, onSorterChange: n } = o;
    r && s(r, e), t && s(t, e), n && s(n, e), l.value = e;
  }
  function x(e, r = "ascend") {
    if (!e)
      m();
    else {
      const t = u.value.find((i) => i.type !== "selection" && i.type !== "expand" && i.key === e);
      if (!(t != null && t.sorter))
        return;
      const n = t.sorter;
      p({
        columnKey: e,
        sorter: n,
        order: r
      });
    }
  }
  function m() {
    y(null);
  }
  function v(e, r) {
    const t = e.findIndex((n) => (r == null ? void 0 : r.columnKey) && n.columnKey === r.columnKey);
    t !== void 0 && t >= 0 ? e[t] = r : e.push(r);
  }
  return {
    clearSorter: m,
    sort: x,
    sortedDataRef: h,
    mergedSortStateRef: a,
    deriveNextSorter: p
  };
}
export {
  T as useSorter
};
